import gql from "graphql-tag";

export const GET_DOWNLOAD_INFO = gql`
    mutation downloadPhoto($photoId: ID!, $downloadTier: PhotoTier!) {
        downloadPhoto(photoId: $photoId, downloadTier: $downloadTier) {
            downloadUrl
            ok
            errors
        }
    }
`;
